import { Component } from '@angular/core';
import { NotificationService } from './notification.service';

@Component({
    selector: 'generic-notification',
    templateUrl: 'generic-notification.component.html',
    styleUrls: ['./generic-notification.component.css'],
    standalone: false
})
export class GenericNotificationComponent {

    constructor(public notificationService: NotificationService) { }

}
